import { IInvoiceTemplateConfigRes } from '@monetize/types/app';
import React from 'react';
import { Control, Controller, FormState } from 'react-hook-form';
import {
  MFlex,
  MFormField,
  MFormFieldProps,
  MSwitch,
} from '../../../../../components/Monetize';

interface IInvoiceTemplateFormProps {
  control: Control<IInvoiceTemplateConfigRes>;
  errors: FormState<IInvoiceTemplateConfigRes>['errors'];
  isDisabled?: boolean;
  handleSubmit: React.FormEventHandler<HTMLFormElement>;
}
export const InvoiceTemplateForm = ({
  control,
  errors,
  isDisabled,
  handleSubmit,
}: IInvoiceTemplateFormProps) => {
  const baseFieldProps: MFormFieldProps = {
    orientation: 'horizontal',
    gap: 4,
    labelProps: { m: 0, fontWeight: 'normal', flex: '1' },
  };

  const fieldProps: MFormFieldProps = {
    ...baseFieldProps,
    py: 3,
    borderBottomWidth: '1px',
    borderBottomColor: 'border.subtle',
  };

  return (
    <>
      <form
        id="customize-invoiceTemplate-form"
        data-testid="customize-invoiceTemplate-form"
        style={{ marginTop: '0' }}
        onSubmit={handleSubmit}
      >
        <>
          <MFlex
            flexDir="column"
            justifyContent="space-between"
            alignItems="center"
            w="100%"
          >
            <MFormField
              label="Show usage products without any usage events"
              {...fieldProps}
              error={errors?.showUsageWithoutEvents}
            >
              <Controller
                name="showUsageWithoutEvents"
                control={control}
                render={({ field: { value, ...rest } }) => (
                  <MSwitch
                    isChecked={value}
                    isDisabled={isDisabled}
                    {...rest}
                  />
                )}
              />
            </MFormField>

            <MFormField
              label="Group invoice line items by offering"
              {...fieldProps}
              error={errors?.showOffering}
              tooltip="When enabled, invoice line items will be grouped by their offering just like the quote."
            >
              <Controller
                name="showOffering"
                control={control}
                render={({ field: { value, ...rest } }) => (
                  <MSwitch
                    isChecked={value}
                    isDisabled={isDisabled}
                    {...rest}
                  />
                )}
              />
            </MFormField>

            <MFormField
              label="Display Price per Unit"
              {...fieldProps}
              error={errors?.showPpu}
              tooltip="When enabled, display the Price per Unit on the invoice for each product."
            >
              <Controller
                name="showPpu"
                control={control}
                render={({ field: { value, ...rest } }) => (
                  <MSwitch
                    isChecked={value}
                    isDisabled={isDisabled}
                    {...rest}
                  />
                )}
              />
            </MFormField>

            <MFormField
              label="Show Bill Date"
              {...fieldProps}
              error={errors?.showBillDate}
              tooltip="When enabled, the invoice displays the Bill Date set by the Bill Group."
            >
              <Controller
                name="showBillDate"
                control={control}
                render={({ field: { value, ...rest } }) => (
                  <MSwitch
                    isChecked={value}
                    isDisabled={isDisabled}
                    {...rest}
                  />
                )}
              />
            </MFormField>

            <MFormField
              label="Show Created Date"
              {...fieldProps}
              error={errors?.showCreatedDate}
              tooltip="When enabled, the invoice displays the date the invoice was created."
            >
              <Controller
                name="showCreatedDate"
                control={control}
                render={({ field: { value, ...rest } }) => (
                  <MSwitch
                    isChecked={value}
                    isDisabled={isDisabled}
                    {...rest}
                  />
                )}
              />
            </MFormField>

            <MFormField
              label="Show Invoice Date"
              {...fieldProps}
              error={errors?.showInvoiceDate}
              tooltip="When enabled, the invoice displays the Invoice Date. This defaults to the Bill Date, but can be edited on a draft invoice."
            >
              <Controller
                name="showInvoiceDate"
                control={control}
                render={({ field: { value, ...rest } }) => (
                  <MSwitch
                    isChecked={value}
                    isDisabled={isDisabled}
                    {...rest}
                  />
                )}
              />
            </MFormField>

            <MFormField
              label="Show Net Terms"
              {...fieldProps}
              error={errors?.showNetTerms}
              tooltip="When enabled, the invoice displays the Net Terms. This defaults to what is defined on the Bill Group, but can be edited on a draft invoice."
            >
              <Controller
                name="showNetTerms"
                control={control}
                render={({ field: { value, ...rest } }) => (
                  <MSwitch
                    isChecked={value}
                    isDisabled={isDisabled}
                    {...rest}
                  />
                )}
              />
            </MFormField>
            {/* <Tooltip
              label={
                requireSigningPage
                  ? 'Signing Sheet will always show because eSign is configured.'
                  : undefined
              }
              size="sm"
            >
              <MFormField {...fieldProps} label="Show Signing Page">
                <Controller
                  name="showSigningPage"
                  control={control}
                  render={({ field: { value, ...rest } }) => (
                    <Switch
                      isChecked={requireSigningPage ? true : value}
                      {...rest}
                      isDisabled={isDisabled || requireSigningPage}
                    />
                  )}
                />
              </MFormField>
            </Tooltip>
             */}
          </MFlex>
        </>
      </form>
    </>
  );
};
